import React, { Component } from "react";
import { DKLabel, DKContactIcon } from "deskera-ui-library";
import {
    COLUMN_CODE,
    TableManger,
    TABLES
} from "../../../managers/TableManger";
import Table from "../../../services/table";
import { getDashboardWidgetLoading } from "../../dashboard/Dashboard";
import { commonCustomEvent, COMMON_EVENTS } from "../../../services/event/commonEvents";
import RouteManager from "../../../managers/RouteManager";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";

interface ICandidateCardProps {
    onCountUpdated: (count: number) => void;
}
interface ICandidateCardState {
    data: any[];
    showLoading: boolean;
}
class CandidatetCard extends Component<ICandidateCardProps, ICandidateCardState> {
    columnsIds = {
        name: "",
        email: "",
        phone: "",
    };
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showLoading: false,
        };
    }
    componentDidMount() {
        this.setColumnsIds();
        this.setState({
            showLoading: true,
        });
        this.fetchRecords();
        document.addEventListener(COMMON_EVENTS.ADD_NEW_REC, (data) => this.onNewRecordAdd(data));
    }
    onNewRecordAdd = (data) => {
        if (data.detail.tableName === TABLES.CANDIDATE) this.fetchRecords();
    }
    componentWillUnmount() {
        document.removeEventListener(COMMON_EVENTS.ADD_NEW_REC, (data) => this.onNewRecordAdd(data));
    }
    render() {
        return (
            <>
                {this.state.showLoading && getDashboardWidgetLoading()}
                {
                    <>
                        {!this.state.showLoading && this.state.data.length !== 0 && (
                            <>
                                <DKLabel
                                    text="Recently added"
                                    className="text-gray fw-m mb-r"
                                />
                                {this.state.data.map((record) => this.getRow(record))}
                            </>
                        )}
                    </>
                }
                {!this.state.showLoading &&
                    this.state.data.length === 0 &&
                    this.getEmptyState()}
            </>
        );
    }

    getRow(data) {

        return (
            <div
                className="row pt-s pb-r justify-content-between listPickerBG cursor-hand"
                onClick={() => {
                    if(PermissionUtils.hasAccess(MODULE.CANDIDATE,ACTION.VIEW)) {
                        RouteManager.navigateToPage(`/candidate/${data.id}`);
                    }                    
                }}
            >
                <div>
                    <div className="row">
                        <DKContactIcon
                            title={`${data[this.columnsIds.name]}`}
                            className="bg-gray1 border-m"
                        />
                        <div className="column ml-r">
                            <DKLabel
                                text={`${(data[this.columnsIds.name]) ? data[this.columnsIds.name] :""}`}
                                className="fw-m"
                            />
                            <DKLabel
                                text={`${data[this.columnsIds.email]
                                        ? data[this.columnsIds.email]
                                        : ""
                                    }`}
                                className="text-gray mt-xs"
                            />
                        </div>
                    </div>
                </div>
                <DKLabel
                    text={`${data[this.columnsIds.phone] ? data[this.columnsIds.phone] : ""
                        }`}
                    className="text-gray"
                />
            </div>
        );
    }
    getEmptyState = () => {
        return (
            <div
                className={`column parent-width parent-height align-items-center justify-content-center`}
            >
                <DKLabel text="No data found" className="fw-m fs-m text-gray" />
                <DKLabel text="Add your first candidate" className="text-gray mt-xs" />
            </div>
        );
    };
    fetchRecords() {
        const contactTableId = TableManger.getTableId(TABLES.CANDIDATE);
        Table.getRecordsByPage(
            { pageNo: 1, pageSize: 10 },
            null,
            contactTableId
        ).then((res: any) => {
            if (this.props.onCountUpdated) this.props.onCountUpdated(res.totalCount);
            this.setState({
                data: res.data.map((record) => {
                    record.cells['id'] = record._id
                    return record.cells
                }),
                showLoading: false,
            });
        });
    }
    setColumnsIds = () => {
        this.columnsIds.name = TableManger.getColumnId(
            TABLES.CANDIDATE,
            COLUMN_CODE.CANDIDATE.NAME
        );
        this.columnsIds.email = TableManger.getColumnId(
            TABLES.CANDIDATE,
            COLUMN_CODE.CANDIDATE.EMAIL
        );
        this.columnsIds.phone = TableManger.getColumnId(
            TABLES.CANDIDATE,
            COLUMN_CODE.CANDIDATE.PHONE
        );
    };
}

export default CandidatetCard;
